import { loadCacheFromLocalStorage, toRestoreGridPage } from '@helpers/localStorage';
import { INITIAL_SORT, DEFAULT_COLUMNS, INITIAL_FILTERS, INITIAL_PAGE } from '../constants';

export const getInitialData = ({
  cacheKey,
  buildingId,
  accountId,
  inspectionId,
  workOrderId,
  showQbInvoiceNumberColumn
}) => {
  const cache = loadCacheFromLocalStorage(cacheKey);
  if (cacheIsValid(cache, cacheKey)) {
    return {
      ...cache,
      page: toRestoreGridPage() && cache.page ? cache.page : INITIAL_PAGE,
      columns: getInitialColumns(
        buildingId,
        accountId,
        inspectionId,
        workOrderId,
        showQbInvoiceNumberColumn,
        cache.columns
      ),
      data: [],
      totalCount: 0,
      selectAll: false,
      loading: true
    };
  }

  return {
    page: INITIAL_PAGE,
    sort: INITIAL_SORT,
    filters: getInitialFilters(buildingId, accountId, inspectionId, workOrderId),
    columns: getInitialColumns(buildingId, accountId, inspectionId, workOrderId, showQbInvoiceNumberColumn),
    data: [],
    totalCount: 0,
    selectAll: false,
    loading: true
  };
};

export const getInitialFilters = (buildingId, accountId, inspectionId, workOrderId) => {
  if (inspectionId) {
    return { ...INITIAL_FILTERS, values: { ...INITIAL_FILTERS.values, inspectionId } };
  }
  if (workOrderId) {
    return { ...INITIAL_FILTERS, values: { ...INITIAL_FILTERS.values, workOrderId } };
  }
  if (buildingId) {
    return { ...INITIAL_FILTERS, values: { ...INITIAL_FILTERS.values, building: buildingId } };
  }
  if (accountId) {
    return { ...INITIAL_FILTERS, values: { ...INITIAL_FILTERS.values, account: accountId } };
  }

  return INITIAL_FILTERS;
};

const QB_INVOICE_COLUMN_SEEN_KEY = 'invoices_qbInvoiceNo_available';

const getInitialColumns = (
  buildingId,
  accountId,
  inspectionId,
  workOrderId,
  showQbInvoiceNumberColumn,
  cachedColumns
) => {
  let columns = DEFAULT_COLUMNS;
  const hasSeenQbColumn = localStorage.getItem(QB_INVOICE_COLUMN_SEEN_KEY) === 'true';

  if (cachedColumns && Array.isArray(cachedColumns)) {
    if (showQbInvoiceNumberColumn) {
      // Flag is ON - check if user has seen this column before
      if (hasSeenQbColumn) {
        // User has seen it before, respect their column choices
        columns = cachedColumns;
      } else {
        // First time flag is ON for this user - inject the column into their cache
        localStorage.setItem(QB_INVOICE_COLUMN_SEEN_KEY, 'true');
        if (!cachedColumns.includes('qbInvoiceNo')) {
          const invoiceNoIndex = cachedColumns.indexOf('invoiceNo');
          columns = [...cachedColumns];
          columns.splice(invoiceNoIndex + 1, 0, 'qbInvoiceNo');
        } else {
          columns = cachedColumns;
        }
      }
    } else {
      // Flag is OFF - filter out qbInvoiceNo and clear the seen flag
      columns = cachedColumns.filter((col) => col !== 'qbInvoiceNo');
      localStorage.removeItem(QB_INVOICE_COLUMN_SEEN_KEY);
    }
  } else if (showQbInvoiceNumberColumn) {
    // No cache - use defaults, adding qbInvoiceNo if flag is ON
    localStorage.setItem(QB_INVOICE_COLUMN_SEEN_KEY, 'true');
    const invoiceNoIndex = DEFAULT_COLUMNS.indexOf('invoiceNo');
    columns = [...DEFAULT_COLUMNS];
    columns.splice(invoiceNoIndex + 1, 0, 'qbInvoiceNo');
  }

  if (inspectionId || workOrderId) {
    return columns.filter((column) => column !== 'invoiceFor' && column !== 'building' && column !== 'account');
  }

  if (buildingId) {
    return columns.filter((column) => column !== 'building' && column !== 'account');
  }
  if (accountId) {
    return columns.filter((column) => column !== 'account');
  }

  return columns;
};

const cacheIsValid = (cache, cacheKey) => {
  if (!cache) return false;

  if (cache.filters && cache.filters.active && cache.filters.values && cache.filters.operators && cache.sort)
    return true;

  localStorage.removeItem(cacheKey);
  return false;
};
